import { ReactElement } from 'react'

import { UserIcon } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'

import { Avatar } from '@shared/components/Avatar'
import { Text } from '@shared/components/Text'

import { useCurrentUser } from '@modules/users/hooks/useCurrentUser'

export const SidebarDesktopCurrentUser = (): ReactElement => {
  const { company, name } = useCurrentUser()

  return (
    <Link
      to="/profile"
      className="group hover:bg-background-primary mx-4 flex items-center gap-2 rounded-lg p-2 transition-all duration-150 hover:shadow-lg"
    >
      <Avatar.Root mode="ROUNDED" size="xxs">
        <Avatar.Content url={''} icon={UserIcon} />
      </Avatar.Root>

      <section className="flex flex-1 flex-col">
        <Text className="font-primary text-text-primary line-clamp-1 max-w-36 text-sm font-semibold" title={name}>
          {name}
        </Text>

        <Text className="font-body text-text-secondary line-clamp-1 max-w-36 text-xs" title={company?.name}>
          {company?.name}
        </Text>
      </section>
    </Link>
  )
}
